/* unplugin-vue-components disabled */import script from "./DramaStatChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaStatChart.vue?vue&type=script&setup=true&lang=js"

import "./DramaStatChart.vue?vue&type=style&index=0&id=fc4f4aa2&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc4f4aa2"]])

export default __exports__